var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconParkHandLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park:hand-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 10.25V4.75H2.5V10.25H1Z",
    fill: "#2F88FF",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.5 4.75005C4.2763 3.1076 5.30608 2.1659 5.5893 1.92496C6.01418 1.56355 6.49435 1.71531 6.49435 2.61975C6.49435 3.5242 5.1784 4.06108 5.1784 4.75005C5.17755 4.75415 6.86775 4.75443 10.249 4.75088C10.6633 4.75043 10.9996 5.08595 11 5.5003V5.50108C11 5.91588 10.6637 6.25213 10.249 6.25213H8.49588C8.19415 8.24428 8.02768 9.32753 7.9964 9.50188C7.94953 9.7634 7.70025 10.2501 6.983 10.2501C6.50483 10.2501 5.01048 10.2501 2.5 10.2501V4.75005Z",
    fill: "#EAC033"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkHandLeft);
export default __webpack_public_path__ + "static/media/icon-park_hand-left.c63b7b80c1fc76ea8c966ca71b8b36b3.svg";
export { ForwardRef as ReactComponent };